<input type="text"
  class="hero-chips-input"
  [formControl]="inputControl"
  (keydown.enter)="onEnterPress()" />

<div class="hero-chips-container">
  <hero-chips [items]="chips"
    (removeItem)="onChipRemove($event)"></hero-chips>
</div>
